import React from 'react';
import { Typography } from 'antd';
import type { AdminProductsListProps } from '../../interfaces';
import AdminProductListItem from '../AdminProductListItem';
import './AdminProductsList.scss';

const { Text } = Typography;

const AdminProductsList: React.FC<AdminProductsListProps> = ({ products, ...props }) => (
  <div className="admin-product-form__product-list">
    {products.map((product) => (
      <AdminProductListItem key={product.id} product={product} {...props} />
    ))}
    {products.length === 0 && <Text type="secondary">No products yet.</Text>}
  </div>
);

export default AdminProductsList;
